import { useContext, useEffect } from 'react';
import { UserContext } from '../../context';

export const useConfigureWallets = () => {
  const [user, { CONFIGURE_WALLETS }] = useContext(UserContext);
  const { id } = user;

  useEffect(() => {
    if (id) {
      CONFIGURE_WALLETS();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
};
